var _defs, _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenantBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_38",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    fill: "#6b7ef2",
    "data-name": "Ellipse 38"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-3{fill:#fff}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Mask_Group_31",
    clipPath: "url(#prefix__clip-path)",
    "data-name": "Mask Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2074",
    "data-name": "Group 2074",
    transform: "rotate(-30 -68.758 123.716)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1521",
    d: "M158.973 85.829v-.314a38.086 38.086 0 0 0-22.439-34.709L57.3 5.1a38.067 38.067 0 0 0-52 13.953l-.21.365A38.071 38.071 0 0 0 8.2 62.039 37.912 37.912 0 0 0 .06 85.572v.4a37.911 37.911 0 0 0 8.24 23.634 38.128 38.128 0 0 0-3.109 42.723l.155.268a38.123 38.123 0 0 0 52.083 13.935l80.687-46.624a38.192 38.192 0 0 0 20.856-33.992v-.088z",
    className: "prefix__cls-3",
    "data-name": "Path 1521",
    transform: "translate(13.927 13.922)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3927",
    width: 76.579,
    height: 158.912,
    fill: "#938aa8",
    "data-name": "Rectangle 3927",
    rx: 38.289,
    transform: "rotate(90 55.766 117.118)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3928",
    width: 76.556,
    height: 171.486,
    fill: "#39bbfc",
    "data-name": "Rectangle 3928",
    rx: 38.278,
    transform: "rotate(60 33.174 152.352)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_3929",
    width: 76.556,
    height: 171.486,
    fill: "#ff4d7f",
    "data-name": "Rectangle 3929",
    rx: 38.278,
    transform: "rotate(119.979 68.651 96.79)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_35",
    cx: 38.278,
    cy: 38.278,
    r: 38.278,
    fill: "#ba6aff",
    "data-name": "Ellipse 35",
    transform: "translate(96.344 61.471)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_36",
    cx: 16.332,
    cy: 16.332,
    r: 16.332,
    className: "prefix__cls-3",
    "data-name": "Ellipse 36",
    transform: "translate(118.29 83.42)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_37",
    cx: 6.635,
    cy: 6.635,
    r: 6.635,
    fill: "#43264f",
    "data-name": "Ellipse 37",
    transform: "translate(127.986 93.116)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantBg2);
export default __webpack_public_path__ + "static/media/tenant_bg2.bd6c706c9c112897703426c7dec7fb5f.svg";
export { ForwardRef as ReactComponent };